import { deepClone } from './utils';
export function createContextManager() {
  var context = {};
  return {
    /** @deprecated use getContext instead */
    get: function get() {
      return context;
    },
    /** @deprecated use setContextProperty instead */
    add: function add(key, value) {
      context[key] = value;
    },
    /** @deprecated renamed to removeContextProperty */
    remove: function remove(key) {
      delete context[key];
    },
    /** @deprecated use setContext instead */
    set: function set(newContext) {
      context = newContext;
    },
    getContext: function getContext() {
      return deepClone(context);
    },
    setContext: function setContext(newContext) {
      context = deepClone(newContext);
    },
    setContextProperty: function setContextProperty(key, property) {
      context[key] = deepClone(property);
    },
    removeContextProperty: function removeContextProperty(key) {
      delete context[key];
    },
    clearContext: function clearContext() {
      context = {};
    }
  };
}